import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  modalMsg: { type: "", msg: "" },
  errorCode: "",
  isShowStartPage: true,
  bannerList: {},
  bannerListPending: false,
  bannerListSuccess: false,
  bannerListFailure: false,
  affiliateIconList: {},
  affiliateIconListPending: false,
  affiliateIconListSuccess: false,
  affiliateIconListFailure: false,
  affiliateList: {},
  affiliateListPending: false,
  affiliateListSuccess: false,
  affiliateListFailure: false,
  // pointAffiliateList: {},
  // pointAffiliateListPending: false,
  // pointAffiliateListSuccess: false,
  // pointAffiliateListFailure: false,
};
const mainSlice = createSlice({
  name: "main",
  initialState,
  reducers: {
    showMsg: (state, payload) => {
      state.modalMsg = {
        msg: payload.payload.msg,
        type: payload.payload.type,
      };
    },
    showStartPage: (state) => {
      state.isShowStartPage = false;
    },
    // **배너 리스트 **
    fetchBannerList: (state) => {
      state.bannerListPending = true;
      state.bannerListSuccess = false;
      state.bannerListFailure = false;
    },
    fetchBannerListSuccess: (state, { payload }) => {
      state.bannerList = payload.data.params;
      state.bannerListPending = false;
      state.bannerListSuccess = true;
      state.bannerListFailure = false;
    },
    fetchBannerListFailure: (state, { payload }) => {
      state.bannerListPending = false;
      state.bannerListSuccess = false;
      state.bannerListFailure = true;
    },

    // **제휴아이콘 리스트 **
    fetchAffiliateIconList: (state) => {
      state.affiliateIconListPending = true;
      state.affiliateIconListSuccess = false;
      state.affiliateIconListFailure = false;
    },
    fetchAffiliateIconListSuccess: (state, { payload }) => {
      state.affiliateIconList = payload.data.params;
      state.affiliateIconListPending = false;
      state.affiliateIconListSuccess = true;
      state.affiliateIconListFailure = false;
    },
    fetchAffiliateIconListFailure: (state, { payload }) => {
      state.affiliateIconListPending = false;
      state.affiliateIconListSuccess = false;
      state.affiliateIconListFailure = true;
    },

    // **제휴사 소개 페이지 **
    fetchAffiliateList: (state) => {
      state.affiliateListPending = true;
      state.affiliateListSuccess = false;
      state.affiliateListFailure = false;
    },
    fetchAffiliateListSuccess: (state, { payload }) => {
      state.affiliateList = payload.data.params;
      state.affiliateListPending = false;
      state.affiliateListSuccess = true;
      state.affiliateListFailure = false;
    },
    fetchAffiliateListFailure: (state, { payload }) => {
      state.affiliateListPending = false;
      state.affiliateListSuccess = false;
      state.affiliateListFailure = true;
    },

    // // **포인트 - 포인트 교환 페이지 리스트 **
    // fetchPointAffiliateList: (state) => {
    //   state.pointAffiliateListPending = true;
    //   state.pointAffiliateListSuccess = false;
    //   state.pointAffiliateListFailure = false;
    // },
    // fetchPointAffiliateListSuccess: (state, { payload }) => {
    //   state.pointAffiliateList = payload.data.params;
    //   state.pointAffiliateListPending = false;
    //   state.pointAffiliateListSuccess = true;
    //   state.pointAffiliateListFailure = false;
    // },
    // fetchPointAffiliateListFailure: (state, { payload }) => {
    //   state.pointAffiliateListPending = false;
    //   state.pointAffiliateListSuccess = false;
    //   state.pointAffiliateListFailure = true;
    // },
  },
});

// 정의한 액션과 리듀서를 export한다.
export const mainActions = mainSlice.actions;
export default mainSlice;
